import { render, staticRenderFns } from "./TreeOptions.vue?vue&type=template&id=2935f151&"
import script from "./TreeOptions.vue?vue&type=script&lang=ts&"
export * from "./TreeOptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports